import {
	post,
	get
} from "./https"



export const getUserInfo = p => post("/api/getUserInfo", p);


//----------------------------------------------------
//登录
export const login = p => post("/api/login", p);
// -----------------------用户端-----------------------
//获取项目列表
export const userProjectList = p => get("/api/projects", p);
//获取积分
export const userScore = p => get("/api/score", p);
//获取项目列表
export const userPro = p => get("/api/projects", p);
//请假
export const userLeave = (p, pd) => post("/api/leave", p, pd);
//取消请假
export const userUnleave = (p, pd) => post("/api/unleave", p, pd);
//获取当天签到信息 
export const signView = (p, pd) => get("/api/sign/view", p, pd);
//签到
export const signSign = (p, pd) => post("/api/sign", p, pd);

// -----------------------員工端-----------------------
//应签到会员列表
export const confirmUsers = (p, pd) => get("/api/confirm/users", p, pd);
//确认签到
export const confirm = (p, pd) => post("/api/confirm", p, pd);
// -----------------------管控端-----------------------
//获取项目列表
export const projectList = p => get("/api/project/list", p);
//新建项目
export const projectNew = p => post("/api/project/new", p);
//获取项目信息
export const projectView = (p, pd) => get("/api/project/view", p, pd);
//获取删除信息
export const projectDelete = (p, pd) => post("/api/project/delete", p, pd);
//获取签到表
export const planView = (p, pd) => get("/api/plan/view", p, pd);
//新建签到表
export const planNew = (p, pd) => post("/api/plan/new", p, pd);
//修改签到表
export const planUpdate = (p, pd) => post("/api/plan/update", p, pd);
//删除签到表
export const planDelete = (p, pd) => post("/api/plan/delete", p, pd);
//获取签到表列表
export const planList = (p, pd) => get("/api/plan/list", p, pd);
//获取项目人员
export const projectUser = (p, pd) => get("/api/project/user", p, pd);
//设置项目人员
export const projectSet = (p, pd) => post("/api/project/user", p, pd);
//获取账号列表
export const accountList = (p, pd) => get("/api/account/list", p, pd);
//获取请假列表
export const leaveList = (p, pd) => get("/api/leave/list", p, pd);
//获取出勤记录
export const signLogs = (p, pd) => get("/api/sign/logs", p, pd);
//删除账号 
export const accountDelete = (p, pd) => post("/api/account/delete", p, pd);
// 新建账号 
export const accountNew = (p, pd) => post("/api/account/new", p, pd);
// 获取账号信息
export const accountView = (p, pd) => get("/api/account/view", p, pd);
// 修改账号
export const accountUpdate = (p, pd) => post("/api/account/update", p, pd);
// 重置密码
export const accountReset = (p, pd) => post("/api/account/reset", p, pd);
//添加积分
export const scoreNew = (p,pd) => post("/api/score/new",p,pd)
//积分记录
export const scoreLogs = (p,pd) => get("/api/score/logs",p,pd)
//批准请假
export const leaveConfirm = (p,pd) => post("/api/leave/confirm",p,pd)
//获取会员积分汇总
export const scoreInfo = (p,pd) => get("/api/score/info",p,pd)
//获取会员考勤汇总
export const signInfo = (p,pd) => get("/api/sign/info",p,pd)
//修改密码
export const changePassword = (p,pd) => post("/api/password",p,pd)
//修改项目名称 
export const changeProjectName = (p,pd) => post("/api/project/update",p,pd)
//导入人员
export const accountImport = (p,pd) => post("/api/account/import",p,pd)
//导入项目人员
export const projectUserImport = (p,pd) => post("/api/project/user-import",p,pd)
